<template>
  <div class="patient-wrap">
    <div class="patient-detail-wrap" v-if="isShowPatientInfo">
      <img src="@/assets/refresh.png" alt="refresh" @click="refreshDetailData">
      <span @click="onBack">이전</span>
      <patient-info :waitPatientInfo='waitPatientInfo' :patientState='patientState' :isPatientSearch='true' :isLoading='isPatientInfoLoading' :errorMsg='errorMsg' @patientChangeState='patientChangeState' />
    </div>
    <div v-else>
      <search @onSearch='onSearch' @onSearchAll='onSearchAll' @refreshData='refreshData' />
      <p class="patient-length-info">
        <span>현재 수진자 인원</span> {{patientData.length}}명
      </p>
      <img src="/static/Rolling.svg" alt="loading" v-if="isLoading">
      <article v-else-if="patientData.length">
        <div :class="{'first-table-wrap': true, 'one-table': patientData.length < 18}">
          <div class="thead">
            <div class="tr">
              <span class="th">
                이름
              </span>
              <span class="th">
                고객번호
              </span>
              <span class="th">
                성별
              </span>
              <span class="th">
                연령
              </span>
              <span class="th">
                위치
              </span>
            </div>
          </div>
          <div class="tbody-wrap">
            <div class="tbody">
              <div class="tr" v-for="(info, index) in firstTableData" :key="index" @click="showPatientInfo(info.chart_num)">
                <span class="td">{{info.pat_nm}}</span>
                <span class="td">{{info.chart_num}}</span>
                <span class="td">{{info.pat_gen}}</span>
                <span class="td">{{info.pat_age}}</span>
                <span class="td">{{info.location}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="second-table-wrap" v-if="patientData.length > 17">
          <div class="thead">
            <div class="tr">
              <span class="th">이름</span>
              <span class="th">고객번호</span>
              <span class="th">성별</span>
              <span class="th">연령</span>
              <span class="th">위치</span>
            </div>
          </div>
          <div class="tbody-wrap">
            <div class="tbody">
              <div class="tr" v-for="(info, index) in patientData.slice(Math.ceil(patientData.length/2))" :key="index" @click="showPatientInfo(info.chart_num)">
                <span class="td">{{info.pat_nm}}</span>
                <span class="td">{{info.chart_num}}</span>
                <span class="td">{{info.pat_gen}}</span>
                <span class="td">{{info.pat_age}}</span>
                <span class="td">{{info.location}}</span>
              </div>
            </div>
          </div>
        </div>
      </article>
      <modal v-else></modal>
    </div>
  </div>
</template>

<script>
import Search from './common/Search'
import Modal from './common/Modal'
import PatientInfo from './common/PatientInfo'
import qs from 'query-string'
export default {
  data () {
    return {
      patientData: [],
      isShowPatientInfo: false,
      patientState: [],
      waitPatientInfo: null,
      patientChartNum: '',
      isLoading: true,
      isPatientInfoLoading: false,
      errorMsg: ''
    }
  },
  created () {
    // 수진자 정보 받아오기
    this.$http.get('/DID_API/search_patient.php').then(result => {
      this.patientData = result.data.data
      this.isLoading = false
    })
      .catch(() => {
        alert('서버에 연결할 수 없습니다.네트워크 연결 상태를 확인하시고 다시 접속을 시도해 주십시오')
        this.isLoading = false
      })
  },
  methods: {
    // 조회 버튼 누를시 처리
    onSearch (name, chartNum) {
      this.isLoading = true
      this.$http.get('/DID_API/search_patient.php', {
        params: {
          pat_nm: name,
          chart_num: chartNum
        }
      }).then(result => {
        this.patientData = result.data.data
        this.isLoading = false
      })
        .catch(() => {
          alert('서버에 연결할 수 없습니다.네트워크 연결 상태를 확인하시고 다시 접속을 시도해 주십시오')
          this.isLoading = false
        })
    },
    // 전체조회 버튼 누를시 처리
    onSearchAll () {
      this.isLoading = true
      this.$http.get('/DID_API/search_patient.php').then(result => {
        this.patientData = result.data.data
        this.isLoading = false
      })
        .catch(() => {
          alert('서버에 연결할 수 없습니다.네트워크 연결 상태를 확인하시고 다시 접속을 시도해 주십시오')
          this.isLoading = false
        })
    },
    // 상세 수진자 정보 띄우기
    showPatientInfo (chartNum) {
      this.patientChartNum = chartNum
      this.isPatientInfoLoading = true
      this.isShowPatientInfo = true
      this.$http.get('/DID_API/patient_detail.php', {
        params: {
          chart_num: chartNum
        }
      })
        .then(result => {
          if (result.data.r_code === 200) {
            this.errorMsg = result.data.r_msg
          } else {
            this.waitPatientInfo = result.data
            this.patientState = result.data.data
          }
          this.isPatientInfoLoading = false
        })
        .catch(() => {
          alert('서버에 연결할 수 없습니다.네트워크 연결 상태를 확인하시고 다시 접속을 시도해 주십시오')
          this.isPatientInfoLoading = false
        })
    },
    // 수진자 정보 새로고침
    refreshData () {
      this.isLoading = true
      this.$http.get('/DID_API/search_patient.php').then(result => {
        this.patientData = result.data.data
        this.isLoading = false
      })
        .catch(() => {
          alert('서버에 연결할 수 없습니다.네트워크 연결 상태를 확인하시고 다시 접속을 시도해 주십시오')
          this.isLoading = false
        })
    },
    // 상세 수진자 정보 새로고침
    refreshDetailData () {
      this.isPatientInfoLoading = true
      this.$http.get('/DID_API/patient_detail.php', {
        params: {
          chart_num: this.patientChartNum
        }
      })
        .then(result => {
          if (result.data.r_code === 200) {
            this.errorMsg = result.data.r_msg
          } else {
            this.waitPatientInfo = result.data
            this.patientState = result.data.data
          }
          this.isPatientInfoLoading = false
        })
        .catch(() => {
          alert('서버에 연결할 수 없습니다.네트워크 연결 상태를 확인하시고 다시 접속을 시도해 주십시오')
          this.isPatientInfoLoading = false
        })
    },
    // 상세 수진자 정보에서 되돌아가기
    onBack () {
      this.isShowPatientInfo = false
      this.patientState = []
      this.patientChartNum = ''
      this.waitPatientInfo = null
    },
    patientChangeState (name, state, roomNum, patNum, treatInfo) {
      let question
      let code
      if (state === '미진행') {
        code = 0
        question = confirm(`${name} 님을 ${treatInfo}실로 이동 하시겠습니까?`)
      } else if (state === '대기중') {
        code = 1
        question = confirm(`${name} 님을 ${treatInfo}실로 호출 하시겠습니까?`)
      } else if (state === '검사중') {
        code = 2
        question = confirm(`${name} 님의 ${treatInfo}실 검사를 완료 하시겠습니까?`)
      } else {
        alert('검사가 완료된 환자 입니다.')
      }
      if (question && !code) {
        this.$http.post(`/DID_API/jubsu.php?room_id=`, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
        this.$http.post('/DID_API/jubsu.php', qs.stringify({
          room_id: roomNum,
          pat_id: patNum
        }), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
          .then(result => {
            if (result.data.r_code === 100) {
              this.refreshDetailData()
            } else {
              alert(result.data.r_msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      } else if (question) {
        this.$http.post('/DID_API/stat_update.php', qs.stringify({
          room_id: roomNum,
          pat_id: patNum,
          stat: code + 1
        }), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
          .then(result => {
            if (result.data.r_code === 100) {
              this.refreshDetailData()
            } else {
              alert(result.data.r_msg)
            }
          })
          .catch(() => {
            alert('서버에 연결할 수 없습니다.네트워크 연결 상태를 확인하시고 다시 접속을 시도해 주십시오')
          })
      }
    }
  },
  components: {
    'search': Search,
    'modal': Modal,
    'patient-info': PatientInfo
  },
  computed: {
    firstTableData () {
      if (this.patientData.length <= 17) {
        return this.patientData
      }
      return this.patientData.slice(0, Math.ceil(this.patientData.length / 2))
    }
  }
}
</script>

<style scoped lang='scss'>
@import './common/table';
.patient-length-info {
  position: absolute;
  top: 100px;
  right: 3vw;
  span {
    margin-right: 10px;
  }
}
.patient-wrap {
  img[alt='loading'] {
    display: block;
    position: absolute;
    width: 80px;
    height: 80px;
    left: 50%;
    margin-left: -40px;
    top: 50%;
    margin-top: -40px;
  }
  .thead {
    .tr {
      height: 6vh;
      line-height: 6vh;
    }
    .th {
      &:first-child {
        width: 8vw;
      }
      &:nth-child(2) {
        width: 12.5vw;
      }
      &:nth-child(3),
      &:nth-child(4) {
        width: 4.75vw;
      }
      &:last-child {
        width: 10vw;
      }
    }
  }
}
.first-table-wrap {
  margin-left: 1.5vw;
  float: left;
  width: 100%;
}

.first-table-wrap,
.second-table-wrap {
  position: relative;
  float: left;
  width: 42.5vw;
  overflow: hidden;
  height: 82vh;
  background-color: white;
  // > div {
  //   height: 100%;
  //   overflow: auto;
  // }
  .tbody-wrap {
    height: 92.8%;
  }
  .tbody {
    .tr {
      height: 4.47vh;
    }
    .td {
      text-align: center;
      padding: 0.6vh;
      &:first-child {
        width: 8vw;
      }
      &:nth-child(2) {
        width: 12.5vw;
      }
      &:nth-child(3),
      &:nth-child(4) {
        width: 4.75vw;
      }
      &:last-child {
        width: 10vw;
      }
    }
  }
}

.one-table {
  width: 85vw;
  height: 82vh;
  margin-left: 1.85vw;
  .thead .th {
    &:first-child {
      width: 22vw;
    }
    &:nth-child(2) {
      width: 19vw;
    }
    &:nth-child(3),
    &:nth-child(4) {
      width: 10vw;
    }
    &:last-child {
      width: 21vw;
    }
  }
  .tbody .td {
    &:first-child {
      width: 22vw;
    }
    &:nth-child(2) {
      width: 19vw;
    }
    &:nth-child(3),
    &:nth-child(4) {
      width: 10vw;
    }
    &:last-child {
      width: 21vw;
    }
  }
}

.second-table-wrap {
  position: relative;
  left: 0.5vw;
}

.patient-detail-wrap {
  span {
    float: right;
    color: #f82600;
    position: relative;
    top: 3vh;
    right: 3.5vw;
    font-size: 26px;
    font-weight: 600;
  }
  img {
    position: absolute;
    display: block;
    top: 1.2vh;
    left: 14.5vw;
    width: 4vw;
  }
}
@media screen and (min-width: 1500px) {
  .patient-detail-wrap img {
    width: 3vw;
  }
  .second-table-wrap,
  .first-table-wrap {
    .thead .tr .th:nth-child(5) {
      width: 9vw;
    }
    .tbody .tr .td:nth-child(5) {
      width: 9vw;
    }
  }
}
@media screen and (min-width: 1300px) and (max-width: 1499px) {
  .first-table-wrap,
  .second-table-wrap {
    height: 85vh;
    .tbody .td {
      padding: 1vh;
    }
  }
  .patient-detail-wrap {
    span {
      font-size: 34px;
    }
  }
}
@media screen and (max-height: 610px) {
  .first-table-wrap,
  .second-table-wrap {
    height: 76vh;
    .tbody {
      .tr {
        height: 4.08vh;
        .td {
          font-size: 14px;
          line-height: 15px;
          padding: 0.4vh;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PatientSearch.vue